import styled, { css } from 'styled-components';

import { Image } from '@xing-com/image';
import { mediaConfined } from '@xing-com/layout-tokens';

const PopupWindowImage = styled(Image)`
  cursor: pointer;
  height: auto;
  width: 100%;
`;

const FullSizeDiv = styled.div<{
  backgroundImageURL?: string;
  mobileBackgroundImageURL?: string;
}>`
  width: 100%;
  height: 100%;
  min-height: 560px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  ${({ backgroundImageURL, mobileBackgroundImageURL }) =>
    backgroundImageURL
      ? css`
          background-image: url(${
            mobileBackgroundImageURL || backgroundImageURL
          });
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          @media ${mediaConfined} {
            background-image: url(${backgroundImageURL});
          }
        `
      : css``};
`;

const FullBackgroundFooter = styled.div`
  width: 100%;
  margin-top: auto;
`;

export const Styled = {
  PopupWindowImage,
  FullSizeDiv,
  FullBackgroundFooter,
};
